const shouldHaveStock = (variant: any) => variant.quantityAvailable > 0

export default shouldHaveStock
